import React from 'react';
import { Flex } from '@components';
import { message,Button } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import NHFetch from '@utils/NHFetch';
import { getLoginUser } from "@utils/NHCore";
import './index.css';
import JbxxForm from './JbxxForm';
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";

export default class NewInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD001_4',
            hjmc: '',
            jbxxFormData: {},
            jbxxInitData: {},
            kzxxInitData: {},
            userBaseInfo: {},
            studentOtherInfo: {},
            stuSsxx: {},
            xsid: '',
            jbxxFlag: true,
            kzxxFlag: true,
            jtcyFlag: true,
            zyshgxFlag: true,
            jyjlFlag: true,
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            isEditJbxx: false,
            isEditJtcy: false,
            isEditZyshgx: false,
            isEditJyjl: false,
            menuList: [],
            zzbdhjid: '',
            lxxxRedis: {},
            blztFlag:'0'
        }
    }
    componentDidMount() {
        this.queryQztjAndYlhj();
        this.getData4Yxwz();
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj']; 
                    this.setState({
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid
                    });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (nohj) {
                        this.setState({ operable: false });
                    }
                }
            });
    }
    // 获取地址参数
    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }
    // 左侧导航菜单
    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }
    // 获取子组件
    getChildComponent = (flag, mode) => {
        switch (flag) {
            case 1:
                this.setState({ jbxxFlag: mode });
                break;
            default:
                break;
        }
    }

    //缓存编写的信息，缓存完之后提交
    cacheFormData = (type, values, isAdd) => {
        if (type == 'jbxx') {
            // console.log('保存:', values)
            const { sjhm,jjlxr,jjlxdh } = values;
            if (sjhm !== null   && jjlxr!=null && jjlxdh!=null) {
                this.setState({
                    jbxxInitData: { ...values },
                    isEditJbxx: true
                }, () => {
                    this.insertData4Yxwz();
                });
            } else {
                message.error("存在必填信息未填写，请填写后再保存！")
            }
        }
    }
    // 获取基本信息
    getData4Yxwz = () => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        // console.log('userId:', userId)
        if (userId) {
            this.setState({ xsid: userId });
            NHFetch('/latestStudent/queryStuInfo', 'GET', { 'xsid': userId })
                .then(res => {
                    // console.log('获取信息:', res)
                    if (res && res.data) {
                        let stuInfo = res.data.stuInfo;
                        // let stuXxcj = res.data.stuXxcj;
                        let stuSsxx = res.data.stuSsxx;
                        let editXszp = res.data.editXszp;
                        let studentOtherInfo=res.data.studentOtherInfo;

                        this.setState({
                            userBaseInfo: stuInfo.userBaseInfo,
                            jbxxInitData: stuInfo.xsJbxx4YxwzVO,
                            // kzxxInitData: { ...stuXxcj },
                            stuSsxx: stuSsxx,
                            editXszp: editXszp,
                            studentOtherInfo:studentOtherInfo
                        });
                    }
                });
        } else {
            message.error("登录超时,请重新登录！");
        }

    }
    // 插入数据
    insertData4Yxwz = () => {
        let postFormData = {};
        // console.log('state:', this.state)
        const { jbxxInitData, xsid, zzbdhjid } = this.state;
        postFormData['xsid'] = xsid;
        postFormData['zzbdhjid']=zzbdhjid;
        postFormData['xsJbxx4YxwzVO'] = jbxxInitData;

        let postData = {
            'xsInfo4YxwzVO': postFormData,
            'params': { 'zzbdhjid': zzbdhjid, 'xsid': xsid },
        };

        //必填一
        const { sjhm ,jjlxr,jjlxdh} = postData.xsInfo4YxwzVO.xsJbxx4YxwzVO;
        let jbxxFlag = false;
        if (sjhm !== null &&  jjlxr!=null && jjlxdh!=null) {
            jbxxFlag = true;
        }
        let hjblFlag = false;
        if (jbxxFlag) hjblFlag = true;
        postData.params.hjblFlag = hjblFlag;

        console.log('更新参数:', postData)
            NHFetch('/latestStudent/updateStuLxxxInfo', 'POST', postData)
            .then(res => {
                if (res && res.code == 200 ) {
                    message.success("保存成功");
                    this.reloadMenu();
                } else {
                    message.error("保存失败");
                }
            });
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    render() {
        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        mkbz={this.state.mkbz}
                        menuType="自助报到"
                    />
                    <Flex.Item className="page_con_r">
                        {/* 导航面包屑 */}
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <Hint />
                            {/* 基本信息栏 */}
                            <JbxxForm ref="refJbxxForm" jbxxFormData={this.state.jbxxInitData}
                                getChildComponent={this.getChildComponent}
                                cacheFormData={this.cacheFormData}
                                userInfoData={this.state.userBaseInfo}
                                stuSsxx={this.state.stuSsxx}
                                editXszp={this.state.editXszp}
                                      studentOtherInfo={this.state.studentOtherInfo}

                            />
                            {/* 下一步按钮 */}
                            <div className="p-sw text-center mt-30">
                                <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                            </div>

                        </div>
                    </Flex.Item>
                </Flex> : <CommonTip hjmc={"个人信息填写"} key={'GD001_4'} mkbz='GD001_4' nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}
